import Axios from 'axios';

export interface LoginCallback
{
    (authenticated: boolean): void;
}

export const sessionMiddleware = (response: any) : Promise<any> => 
{
    return new Promise((resolve, reject) => {
        let urlSessionEnded = '/login?sessionHasEnded=true';
        if( response.request.responseURL.includes(urlSessionEnded) &&
            !window.location.href.includes(urlSessionEnded))
        {
            reject({
                error: "Session Has Ended"
            });
            window.location.href = response.request.responseURL;
        }
        else
        {
            resolve(response);
        }
    });
}

export default class LoginAPI
{
    // ------- LOGIN ------- //

    static login(username: string, password: string) : Promise<string>
    {
        return Axios.post('./authenticate', {}, {
            auth: {
                username: username,
                password: password
            }
        }).then((response: any) => {
            return response.request.responseURL;
        }).catch((error: any) => {
            console.log(error);
            return window.location.href;
        });
    }

    // ------- LOGOUT ------- //

    static logout() : Promise<string>
    {
        return Axios.post('./logout').then((response: any) => {
            return response.request.responseURL;
        }).catch((error: any) => {
            console.log(error);
            return window.location.href;
        });
    }

    // ---- SESSION CHECK ---- //

    static check() : Promise<string>
    {
        return Axios.post(
            './checkSession', 
            {}
        ).then((response: any) => {
            if( !response.request.responseURL.includes('/checkSession')
                &&
                response.request.responseURL !== undefined
                &&
                response.request.responseURL !== "undefined" )
            {
                return response.request.responseURL;
            }
            else
            {
                return window.location.href; 
            }
        }).catch((error: any) => {
            console.log(error);
            return window.location.href;
        });
    }

    // ---------------------- //
}